var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-form__input-row"},[_c('div',{ref:"inputs",staticClass:"input-row__inputs-container"},[_vm._t("inputs")],2),_c('div',{staticClass:"input-row__description"},[(_vm.focused)?_vm._t("description"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }